export default __webpack_public_path__ + "static/media/gallery_08.002ea44d.jpg";